export default __webpack_public_path__ + "static/media/mh-logo-text-modern.ac77c160.svg";